import { useMemo } from 'react';
import useToggle from '../useToggle';
export default function useBoolean(defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }

  var _useToggle = useToggle(defaultValue),
      state = _useToggle[0],
      toggle = _useToggle[1].toggle;

  var actions = useMemo(function () {
    var setTrue = function setTrue() {
      return toggle(true);
    };

    var setFalse = function setFalse() {
      return toggle(false);
    };

    return {
      toggle: toggle,
      setTrue: setTrue,
      setFalse: setFalse
    };
  }, [toggle]);
  return [state, actions];
}